import { EmployeesCtrl } from "./controllers/employees";
import { EmployeeService } from "./services/employeeService";
import environment from "@gtmhub/env/module";

const employeesCoreMod = angular.module("employeesCore", [environment]).service("EmployeeService", EmployeeService).controller("EmployeesCtrl", EmployeesCtrl);

export default employeesCoreMod.name;
